import api from "api";

import { endpoints } from "config";
import ToastMessage, { toastConfig } from "helpers/ToastMessage/ToastMessage";
import { parseCamelCase } from "helpers/parseCamelCase";
import React, { Dispatch, useEffect, useState } from "react";
import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  selectParentId,
  setCloseRightMenu,
  setParentId,
} from "reducers/listPage";
import { setCloseParentMenu } from "reducers/parentCrudMenu";
import {
  clearSubmitResponseErrors,
  selectSubmitResponse,
  setSubmitResponseErrors,
} from "reducers/submitResponse";

const handleFileChange = async (
  e: any,
  item: any,
  onDone: () => void,
  projectId?: number | null,
  curRef?: any
) => {
  const file = e.target.files[0];

  if (
    file &&
    file.name &&
    Array.isArray(item.additionalDataIDs) &&
    item.additionalDataIDs.length > 0 &&
    item.additionalDataIDs[0] &&
    typeof item.additionalDataIDs[0] === "object" &&
    item.additionalDataIDs[0].hasOwnProperty("id")
  ) {
    // Handle the file as per your requirement
    const dataIds: number[] = item.additionalDataIDs.map(
      (item: any) => item.id
    );
    // const currentDocumentVersion = item.additionalDataIDs[0].documents__DocumentVersion

    const formData = new FormData();
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
      // params: {
      //   id: dataId,
      // },
    };
    if (projectId && item.permissionKey === "documents-upload") {
      formData.append("ProjectsId", String(projectId));
    }
    formData.append("file", file, (file as File)?.name ?? undefined);
    dataIds.forEach(item => {
      formData.append("idsToUpload", String(item));
    });

    const url =
      item.permissionKey === "documents-upload"
        ? endpoints.projectmanagement.nestedPages.documents.upload
        : endpoints.documents.uploadNewVersion;
    try {
      const response = await api.post(url, formData, config);

      if (response.status === 200 && response.data.status === `1`) {
        // helpers.setSubmitting(false);

        if (item.dispatch) {
          item.dispatch(
            setSubmitResponseErrors({ submitResponseErrors: null })
          );
        }

        onDone();
      } else {
        if (item.dispatch) {
          item.dispatch(
            setSubmitResponseErrors({ submitResponseErrors: null })
          );
        }
      }
    } catch (err) {
      const error: any = err;

      if (
        error.response &&
        error.response.data &&
        error.response.data.errors &&
        Array.isArray(error.response.data.errors) &&
        error.response.data.errors.length > 0
      ) {
        const unparsedErrors = error.response.data.errors;
        let parsedErrors: any = {};

        unparsedErrors.forEach((item: any) => {
          if (
            typeof item === "object" &&
            item.hasOwnProperty("fieldName") &&
            item.hasOwnProperty("messageCode")
          ) {
            const parsedFieldName = parseCamelCase(item.fieldName)
              .split("_")
              .join(" ")
              .replace("_", "")
              .replaceAll(/  +/g, " ")
              .trim();
            const parsedMessageCode = item.messageCode
              .split("_")
              .join(" ")
              .replace("_", "")
              .replaceAll(/  +/g, " ")
              .trim();
            parsedErrors[parsedFieldName] = parsedMessageCode;
          }
        });

        if (Object.keys(parsedErrors).length > 0 && item.dispatch) {
          // helpers.setErrors(parsedErrors);

          item.dispatch(
            setSubmitResponseErrors({ submitResponseErrors: parsedErrors })
          );
        }
      } else {
        if (item.dispatch) {
          item.dispatch(
            setSubmitResponseErrors({ submitResponseErrors: true })
          );
        }
      }
    } finally {
      if (curRef) curRef.value = "";
    }
  } else {
    if (curRef) curRef.value = "";
  }
};

export const FilePicker = (item?: any) => {
  const inputFile = useRef<any>(null);
  const parentId = useSelector(selectParentId);
  const onClick = (e: any) => {
    inputFile.current?.click();
  };

  const dispatch = useDispatch();

  const submitResponseErrors = useSelector(selectSubmitResponse)
    .submitResponseErrors;
  const hasMounted = useRef<boolean>(false);

  useEffect(() => {
    if (submitResponseErrors && hasMounted.current) {
      toast(
        <ToastMessage
          toastData={Object.entries(submitResponseErrors).map(
            ([title, text]: [string, any]) => ({
              title,
              text,
            })
          )}
          className="ToastError"
        />,
        {
          ...toastConfig,
        }
      );
    }
    if (!hasMounted.current) {
      dispatch(clearSubmitResponseErrors());
      hasMounted.current = true;
    }
  }, [submitResponseErrors]);

  const onDone = () => {
    toast(
      <ToastMessage
        toastData={[
          { title: "File uploaded", text: "New document version uploaded" },
        ]}
        className="ToastSuccess"
      />,
      {
        ...toastConfig,
      }
    );
    if (item.permissionKey !== "documents-upload") {
      dispatch(setCloseRightMenu());
    }
  };

  // return item && item.position === "RightMenu" ? (
  return item.position === "RightMenu" ? (
    <div className={item.disabled ? "Item Disabled" : "Item"} onClick={onClick}>
      <input
        type="file"
        id="file"
        ref={inputFile}
        style={{ display: "none" }}
        onChange={e => {
          handleFileChange(e, item, onDone, parentId, inputFile.current);
        }}
      />
      {/* <button onClick={onClick}>open file browser</button> */}
      <span>{item.name as string}</span>
    </div>
  ) : // ) : item && item.position === "TableRowOption" ? (
  item.position === "TableRowOption" ? (
    <span
      className={`OptionItem ${item.disabled ? "Disabled" : ""}`}
      onClick={onClick}
      key={item.name}
    >
      <input
        type="file"
        id="file"
        ref={inputFile}
        style={{ display: "none" }}
        onChange={e =>
          handleFileChange(e, item, onDone, parentId, inputFile.current)
        }
      />
      {item.name}
    </span>
  ) : (
    <></>
  );
};
